import React from "react";
import TextField from "../../Utils/FormInputs/TextField";
import { formatAmount } from "../../Utils/formatAmount";
import { useEditPurchase } from "./CustomHooks/useEditPurchase";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import { connect } from "react-redux";
import { AutoCompleteControlled } from "../../Utils/FormInputs/AutoCompleteInput";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import { BackButton } from "../../Utils/FormInputs/BackButton";
import { history } from "../../Helpers/history";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";

function EditPurchase({ actions, snackbars, match: { params } }) {
  const { purchase_id } = params;

  const {
    rows,
    manufacturer_name,
    handleChangeBatch,
    invoice_no,
    purchase_date,
    grand_total,
    manufs,
    submitted,
    handleChangeValue,
    handleChangeManufacturer,
    handleChangeQuantity,
    handleChangePrice,
    handleChangeExpiryDate,
    handleSubmitPurchase,
    handleCloseSnackbar,
  } = useEditPurchase(actions, purchase_id);

  const { open, variant, message } = snackbars;

  const styles = {
    container: {
      padding: "1.5rem",
      maxWidth: "1200px",
      margin: "0 auto",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    title: {
      fontSize: "1.75rem",
      fontWeight: "bold",
      marginBottom: "1rem",
    },
    formGroup: {
      marginBottom: "1rem",
    },
    label: {
      display: "block",
      fontWeight: 600,
      marginBottom: "0.25rem",
    },
    input: {
      width: "100%",
      padding: "0.5rem 0.75rem",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "0.95rem",
      boxSizing: "border-box",
    },
    disabledInput: {
      backgroundColor: "#f5f5f5",
      cursor: "not-allowed",
    },
    tableWrapper: {
      width: "100%",
      overflowX: "auto",
      marginTop: "1rem",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "0.875rem",
      minWidth: "800px",
    },
    th: {
      padding: "0.5rem 0.75rem",
      border: "1px solid #ddd",
      textAlign: "center",
      backgroundColor: "#f0f0f0",
      fontWeight: 600,
    },
    td: {
      padding: "0.5rem 0.75rem",
      border: "1px solid #ddd",
      textAlign: "center",
    },
    rowEven: {
      backgroundColor: "#f9f9f9",
    },
    rowHover: {
      backgroundColor: "#f1f7ff",
    },
    submitWrapper: {
      marginTop: "1.5rem",
      textAlign: "right",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "0.5rem 1rem",
      fontSize: "1rem",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
  };

  return (
    <div style={styles.container}>
      {/* <h1 style={styles.title}>Edit Purchase</h1> */}
    {/* Dashboard Header */}
    <ReusableDashboardHeader
      component="Edit Purchase"
      heading="Edit Purchase"
      subHeading="Edit Purchase"
      link={history.location.pathname}
    />



    {/* Back Button */}
    <div className="mb-4">
      <BackButton text="Purchases List " to="/managepurchase" />
    </div>

      {/* Snackbar */}
      <PharmacySnackbar
        open={open}
        variant={variant}
        message={message}
        handleCloseBar={handleCloseSnackbar}
      />

      {/* Supplier Selection */}
      <div style={styles.formGroup}>
        <label style={styles.label}>Supplier</label>
        <AutoCompleteControlled
          options={manufs}
          submitted={submitted}
          testId="supplier"
          handleChange={handleChangeManufacturer}
          errorMsg="Please select a supplier"
          medicine_value={manufacturer_name}
          value_text="manufacturer_id"
          label_text="manufacturer_name"
        />
      </div>

      {/* Invoice Number */}
      <div style={styles.formGroup}>
        <label style={styles.label}>Invoice Number</label>
        <TextField
          name="invoice_no"
          data-testid="invoice_no"
          type="text"
          value={invoice_no}
          onChange={handleChangeValue}
          style={styles.input}
        />
      </div>

      {/* Purchase Date */}
      <div style={styles.formGroup}>
        <label style={styles.label}>Purchase Date</label>
        <TextField
          name="purchase_date"
          data-testid="purchase_date"
          type="date"
          value={purchase_date}
          onChange={handleChangeValue}
          style={styles.input}
        />
      </div>

      {/* Grand Total */}
      <div style={styles.formGroup}>
        <label style={styles.label}>Grand Total</label>
        <TextField
          name="grand_total"
          data-testid="grand_total"
          type="number"
          value={grand_total}
          disabled
          style={{ ...styles.input, ...styles.disabledInput }}
        />
      </div>

      {/* Products Table */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              {[
                "Product",
                "Batch #",
                "Quantity*",
                "Unit Cost",
                "Expiry Date*",
                "Retail",
                "Wholesale",
                "Total",
                "Balance",
                "Sold qty",
              ].map((header) => (
                <th key={header} style={styles.th}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((item, idx) => (
              <tr
                key={item.uuid_id}
                style={idx % 2 === 0 ? styles.rowEven : {}}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f1f7ff")}
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = idx % 2 === 0 ? "#f9f9f9" : "white")
                }
              >
                <td style={styles.td}>{item.product_name}</td>
                <td style={styles.td}>
                  <TextField
                    type="text"
                    value={item.batch_id || ""}
                    onChange={(e) => handleChangeBatch(e, idx)}
                    style={styles.input}
                  />
                </td>
                <td style={styles.td}>
                  <TextField
                    type="number"
                    value={item.product_quantity}
                    onChange={(e) => handleChangeQuantity(e, idx)}
                    style={styles.input}
                  />
                </td>
                <td style={styles.td}>
                  <TextField
                    data-testid={"product_rate-" + idx}
                    name="product_rate"
                    onChange={(e) => handleChangePrice(e, idx)}
                    value={item.product_rate}
                    style={styles.input}
                  />
                </td>
                <td style={styles.td}>
                  <TextField
                    type="date"
                    value={item.expiry_date || ""}
                    onChange={(e) => handleChangeExpiryDate(e, idx)}
                    style={styles.input}
                  />
                </td>
                <td style={styles.td}>
                  <TextField type="number" value={item.retail_price || 0} disabled style={{ ...styles.input, ...styles.disabledInput }} />
                </td>
                <td style={styles.td}>
                  <TextField type="number" value={item.wholesale_price || 0} disabled style={{ ...styles.input, ...styles.disabledInput }} />
                </td>
                <td style={styles.td}>
                  <TextField type="number" value={item.total_price} disabled style={{ ...styles.input, ...styles.disabledInput }} />
                </td>
                <td style={styles.td}>
                  <TextField type="number" value={item.balance || 0} disabled style={{ ...styles.input, ...styles.disabledInput }} />
                </td>
                <td style={styles.td}>
                  <TextField type="number" value={item.qty_sold || 0} disabled style={{ ...styles.input, ...styles.disabledInput }} />
                </td>
              </tr>
            ))}
            {rows.length > 0 && (
              <tr>
                <td colSpan={7} style={{ ...styles.td, textAlign: "right", fontWeight: "bold" }}>
                  Grand Total:
                </td>
                <td style={styles.td}>{formatAmount(grand_total)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Submit Button */}
      <div style={styles.submitWrapper}>
        <button
          style={styles.button}
          onClick={handleSubmitPurchase}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0056b3")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#007bff")}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
  return { actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPurchase);
